import React from "react";

const CMYKMarkSpread = ({ size = 60, offset = 5 }) => {
  const center = size / 2;
  const radius = center - size * 0.1; // Outer circle radius
  const innerRadius = size * 0.1; // Inner circle radius
  const colors = ["#00FFFF", "#FF00FF", "#FFFF00", "#000000"]; // Cyan, Magenta, Yellow, Black

  return (
    <svg
      width={size}
      height={size + offset * 3} // Increase SVG height to accommodate offsets
      viewBox={`0 0 ${size} ${size + offset * 3}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      {colors.map((color, index) => (
        <g key={color} transform={`translate(0, ${offset * index})`}>
          {/* Outer Circle */}
          <circle
            cx={center}
            cy={center}
            r={radius}
            stroke={color}
            strokeWidth={size * 0.03}
            fill="none"
          />
          {/* Inner Circle */}
          <circle
            cx={center}
            cy={center}
            r={innerRadius}
            stroke={color}
            strokeWidth={size * 0.03}
            fill="none"
          />
          {/* Vertical Line */}
          <line
            x1={center}
            y1="0"
            x2={center}
            y2={size}
            stroke={color}
            strokeWidth={size * 0.03}
          />
          {/* Horizontal Line */}
          <line
            x1="0"
            y1={center}
            x2={size}
            y2={center}
            stroke={color}
            strokeWidth={size * 0.03}
          />
        </g>
      ))}
    </svg>
  );
};

export default CMYKMarkSpread;
